module.exports = __webpack_public_path__ + "media/photo/comunication_bg-d361d265.jpg";